<script setup>
const gsapTimeline = useGsapTimeline()
defineProps({
  text: {
    type: String,
    required: true,
  },
})

const emit = defineEmits(['timeline'])

const boldCharactersElement = ref(null)
const outlineCharactersElement = ref(null)

onMounted(() => {
  const boldCharactersChildren = boldCharactersElement.value.children
  const outlineCharactersChildren = outlineCharactersElement.value.children

  const timeline = gsapTimeline()
    .set([boldCharactersElement, outlineCharactersElement], { visibility: 'inherit' })
    .from(boldCharactersChildren, { scale: 0.61, duration: 0.08, transformOrigin: 'bottom right', stagger: { amount: 0.2 }, ease: 'power1.out' })
    .from(outlineCharactersChildren, { fontSize: 500, letterSpacing: '-30px', duration: 0.08, transformOrigin: 'bottom left', stagger: { amount: 0.2 }, ease: 'power1.out' }, '<')
    .from(boldCharactersElement, { y: '-100px', duration: 0.04, ease: 'power2.out' }, '<0.08')
    .from(outlineCharactersElement, { y: -180, duration: 0.12 }, '<')
    .to(boldCharactersElement, { right: 1390, skewX: -25, duration: 0.16, ease: 'power2.out' })
    .to(outlineCharactersElement, { left: 1190, skewX: 25, duration: 0.16, ease: 'power2.out' }, '<')
    .set([boldCharactersElement, outlineCharactersElement], { visibility: 'hidden' })

  emit('timeline', timeline)
})
</script>

<template>
  <div ref="boldCharactersElement" class="invisible absolute z-50 -top-3 right-[1000px] text-q-cr-red-primary text-[975px] font-semibold flex whitespace-nowrap">
    <div v-for="char in text" :key="char" class="left-0">{{ char }}</div>
  </div>
  <div ref="outlineCharactersElement" class="invisible absolute z-40 bottom-[-80px] left-[800px] text-transparent text-[720px] font-semibold flex whitespace-nowrap text-stroke-5 text-stroke-white">
    <div v-for="char in text" :key="char" class="left-0 text-center">{{ char }}</div>
  </div>
</template>
